module.exports = __webpack_public_path__ + "static/media/journal-grad-medical-ed.2af7c906.gif";